import React from 'react'
import PropTypes from 'prop-types'
import cssModules from 'react-css-modules'
import styles from './avatar.less'
import Icon from '../icon'

export const avatarColors = [
  'orange',
  'purple',
  'blue',
  'green',
  'grey',
  'white',
]

class Avatar extends React.Component {
  static propTypes = {
    icon: PropTypes.string,
    imageUrl: PropTypes.string,
    initials: PropTypes.string,
    backgroundColor: PropTypes.oneOf(avatarColors),
    blank: PropTypes.bool,
    glow: PropTypes.bool,
    small: PropTypes.bool,
  }

  render() {
    let avatarStyle = {}
    const backgroundStyle = this.props.backgroundColor || 'white'
    let noAvatarElement = ''
    if (!this.props.blank) {
      if (this.props.imageUrl) {
        avatarStyle.backgroundImage = `url("${this.props.imageUrl}")`
      }

      if (!this.props.imageUrl) {
        if (this.props.icon) {
          noAvatarElement = (
            <Icon iconSize="huge" type={this.props.icon} strokeColor="white" />
          )
        } else if (this.props.initials) {
          noAvatarElement = (
            <div styleName={this.props.small ? 'small-initials ' : 'initials'}>
              {this.props.initials}
            </div>
          )
        } else {
          noAvatarElement = (
            <div styleName="no-avatar">
              <Icon type="profile" />
            </div>
          )
        }
      }
    }

    const stylesArray = ['avatar', backgroundStyle]
    if (this.props.blank) stylesArray.push('blank')
    if (this.props.glow) stylesArray.push('glow')
    if (this.props.small) stylesArray.push('smaller-shadow')

    return (
      <div styleName={stylesArray.join(' ')} style={avatarStyle}>
        {noAvatarElement}
      </div>
    )
  }
}

export default cssModules(Avatar, styles, { allowMultiple: true })
